// Demo catalog for DevPOS. Edit freely: it is only written to a browser
// that has no DevPOS data yet (or after a reset with ?demo=reset).

export const company = {
  name: "DevPOS Demo Cafe",
  header: "12 Market Street, Downtown\nTel: (555) 010-2030",
  footer: "Thank you, see you again soon!",
  countryCode: "USD",
  tax: "0",
  companyLanguage: "en",
};

export const roles = ["Owner", "Manager", "Cashier"];

export const attendants = [
  { user_name: "Owner", pin_code: "1234", role: "Owner", canLogin: true, canApprove: true },
  { user_name: "Sarah", pin_code: "1111", role: "Manager", canLogin: true, canApprove: true },
  { user_name: "Mike", pin_code: "2222", role: "Cashier", canLogin: true, canApprove: false },
];

export const customers = [
  { name: "Emma Wilson", email: "emma.wilson@example.com", phoneNumber: "555-0101", note: "Oat milk only" },
  { name: "Liam Carter", email: "liam.carter@example.com", phoneNumber: "555-0102", note: "Office orders on Fridays" },
  { name: "Olivia Brown", email: "olivia.brown@example.com", phoneNumber: "555-0103", note: "Loyalty member" },
  { name: "Noah Davis", email: "noah.davis@example.com", phoneNumber: "555-0104", note: "" },
  { name: "Ava Martinez", email: "ava.martinez@example.com", phoneNumber: "555-0105", note: "Prefers decaf" },
];

export const discounts = [
  { name: "Loyalty 10%", value: 10, percentageType: "percentage" },
  { name: "Senior 20%", value: 20, percentageType: "percentage" },
  { name: "Staff 50%", value: 50, percentageType: "percentage" },
  { name: "2 Off Coupon", value: 2, percentageType: "fixDiscount" },
];

export const categories = [
  { name: "Hot Coffee", color: "firebrick" },
  { name: "Iced Drinks", color: "blue" },
  { name: "Tea", color: "green" },
  { name: "Bakery", color: "darkorange" },
  { name: "Sandwiches", color: "tomato" },
  { name: "Desserts", color: "darkmagenta" },
  { name: "Retail", color: "gray" },
];

// image is a file in web/public/items (see CREDITS.md there), leave it out
// to show the colour and shape instead.
// popularity drives how often an item shows up in the sales history
export const items = [
  { name: "Espresso", image: "espresso.jpg", category: "Hot Coffee", price: 2.5, sku: "HC-001", barcode: "890100000011", shape: "circle", favorite: true, popularity: 8 },
  { name: "Americano", image: "americano.jpg", category: "Hot Coffee", price: 3.0, sku: "HC-002", barcode: "890100000028", shape: "circle", favorite: true, popularity: 9 },
  { name: "Cappuccino", image: "cappuccino.jpg", category: "Hot Coffee", price: 3.75, sku: "HC-003", barcode: "890100000035", shape: "circle", favorite: true, popularity: 10 },
  { name: "Cafe Latte", image: "cafe-latte.jpg", category: "Hot Coffee", price: 4.0, sku: "HC-004", barcode: "890100000042", shape: "circle", favorite: true, popularity: 10 },
  { name: "Flat White", image: "flat-white.jpg", category: "Hot Coffee", price: 3.9, sku: "HC-005", barcode: "890100000059", shape: "circle", popularity: 6 },
  { name: "Mocha", image: "mocha.jpg", category: "Hot Coffee", price: 4.5, sku: "HC-006", barcode: "890100000066", shape: "circle", popularity: 5 },

  { name: "Iced Latte", image: "iced-latte.jpg", category: "Iced Drinks", price: 4.25, sku: "IC-001", barcode: "890100000110", shape: "square", favorite: true, popularity: 8 },
  { name: "Cold Brew", image: "cold-brew.jpg", category: "Iced Drinks", price: 4.0, sku: "IC-002", barcode: "890100000127", shape: "square", popularity: 6 },
  { name: "Iced Mocha", image: "iced-mocha.jpg", category: "Iced Drinks", price: 4.75, sku: "IC-003", barcode: "890100000134", shape: "square", popularity: 4 },
  { name: "Lemonade", image: "lemonade.jpg", category: "Iced Drinks", price: 3.25, sku: "IC-004", barcode: "890100000141", shape: "square", popularity: 4 },
  { name: "Orange Juice", image: "orange-juice.jpg", category: "Iced Drinks", price: 3.5, sku: "IC-005", barcode: "890100000158", shape: "square", popularity: 3 },

  { name: "English Breakfast", image: "english-breakfast.jpg", category: "Tea", price: 2.75, sku: "TE-001", barcode: "890100000219", shape: "certificate", popularity: 4 },
  { name: "Green Tea", image: "green-tea.jpg", category: "Tea", price: 2.75, sku: "TE-002", barcode: "890100000226", shape: "certificate", popularity: 3 },
  { name: "Chai Latte", image: "chai-latte.jpg", category: "Tea", price: 3.95, sku: "TE-003", barcode: "890100000233", shape: "certificate", favorite: true, popularity: 5 },

  { name: "Butter Croissant", image: "butter-croissant.jpg", category: "Bakery", price: 2.95, sku: "BK-001", barcode: "890100000318", shape: "square", favorite: true, popularity: 9 },
  { name: "Chocolate Croissant", image: "chocolate-croissant.jpg", category: "Bakery", price: 3.45, sku: "BK-002", barcode: "890100000325", shape: "square", popularity: 6 },
  { name: "Blueberry Muffin", image: "blueberry-muffin.jpg", category: "Bakery", price: 2.85, sku: "BK-003", barcode: "890100000332", shape: "square", popularity: 6 },
  { name: "Cinnamon Roll", image: "cinnamon-roll.jpg", category: "Bakery", price: 3.25, sku: "BK-004", barcode: "890100000349", shape: "square", popularity: 5 },
  { name: "Bagel with Cream Cheese", image: "bagel-with-cream-cheese.jpg", category: "Bakery", price: 3.75, sku: "BK-005", barcode: "890100000356", shape: "square", popularity: 4 },

  { name: "Ham and Cheese Panini", image: "ham-and-cheese-panini.jpg", category: "Sandwiches", price: 7.5, sku: "SW-001", barcode: "890100000417", shape: "bookmark", popularity: 5 },
  { name: "Turkey Club", image: "turkey-club.jpg", category: "Sandwiches", price: 8.25, sku: "SW-002", barcode: "890100000424", shape: "bookmark", popularity: 4 },
  { name: "Veggie Wrap", image: "veggie-wrap.jpg", category: "Sandwiches", price: 6.95, sku: "SW-003", barcode: "890100000431", shape: "bookmark", popularity: 3 },
  { name: "Avocado Toast", image: "avocado-toast.jpg", category: "Sandwiches", price: 6.5, sku: "SW-004", barcode: "890100000448", shape: "bookmark", favorite: true, popularity: 5 },

  { name: "Cheesecake Slice", image: "cheesecake-slice.jpg", category: "Desserts", price: 4.95, sku: "DS-001", barcode: "890100000516", shape: "circle", popularity: 4 },
  { name: "Chocolate Brownie", image: "chocolate-brownie.jpg", category: "Desserts", price: 3.25, sku: "DS-002", barcode: "890100000523", shape: "circle", popularity: 5 },
  { name: "Carrot Cake", image: "carrot-cake.jpg", category: "Desserts", price: 4.5, sku: "DS-003", barcode: "890100000530", shape: "circle", popularity: 3 },

  { name: "House Blend Beans 250g", image: "house-blend-beans-250g.jpg", category: "Retail", price: 12.5, sku: "RT-001", barcode: "890100000615", shape: "square", popularity: 2 },
  { name: "Reusable Cup", image: "reusable-cup.jpg", category: "Retail", price: 9.95, sku: "RT-002", barcode: "890100000622", shape: "square", popularity: 1 },
  { name: "Bottled Water", image: "bottled-water.jpg", category: "Retail", price: 1.5, sku: "RT-003", barcode: "890100000639", shape: "square", popularity: 5 },
];

// days of sales history before today, and receipts per day
export const history = {
  days: 7,
  receiptsPerDay: [14, 22],
  receiptsToday: 6,
  beginningCash: 150,
};

export const printer = {
  name: "Browser Printer",
  macAddress: "BROWSER-PRINTER",
  defaultPrinter: true,
};
